import GemMeterBaseRule from '../GemMeterBaseRule';
import { HARD_TO_CLICK_BUTTON } from '../../../constants/rulesConstants';

export default class ButtonMinSizeRule extends GemMeterBaseRule {
  static ruleId = HARD_TO_CLICK_BUTTON.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return true;
    }

    const style = getComputedStyle(element);

    return element.clientHeight + parseFloat(style.borderWidth) * 2 >= 38;
  }
}
